import React, { useEffect } from 'react';
import { Prompt } from 'react-router-dom';

const DEFAULT_MESSAGE = 'Are you sure you want to leave this page? You will lose any unsaved changed.';

interface Props {
    when: boolean;
    message?: string;
}

export default function BlockNavigation({ when: shouldBlockNavigation, message = DEFAULT_MESSAGE }: Props) {
    useEffect(() => {
        if (shouldBlockNavigation) {
            window.onbeforeunload = () => message;
        } else {
            window.onbeforeunload = null;
        }
        return function cleanup() {
            window.onbeforeunload = null;
        };
    }, [shouldBlockNavigation, message]);

    return <Prompt when={shouldBlockNavigation} message={message} />;
}
